import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'mathRound'
})
export class MathRoundPipe implements PipeTransform {

  transform(value: number, ...args: unknown[]): number {
    return Math.round(value * 100) / 100;
  }

}
